import React from "react";
import { BsSearch } from "react-icons/bs";
import { FaGreaterThan,FaArrowCircleLeft, FaRegBell, FaRegUser } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
export default function Topbar(props) {
  let navigate = useNavigate();
  const backFunction = () => {
    navigate(-1);
  };
  return (
    <nav className="absolute xl:w-[calc(100%-280px)] w-[calc(100%-240px)] top-0 xl:ml-[280px] ml-60 py-8 px-10 float-right">
      <div className="bg-white px-5 py-4 flex items-center justify-between rounded-lg">
        <div className="flex items-center gap-x-2">
          <FaArrowCircleLeft  onClick={backFunction} size={24} className="cursor-pointer" />
          <h1
           
            className="font-medium text-2xl"
          >
            {props.main}
          </h1>
          {props.extend && (
            <>
              <span>
                <FaGreaterThan
                  className="text-black text-opacity-60"
                  size={12}
                />
              </span>
              <span className="font-medium text-base text-black text-opacity-60">
                {props.sub}
              </span>
            </>
          )}
        </div>
        <div className="flex items-center gap-x-4">
          
       
          <Link to="/profile" className="bg-themeBlue p-2 rounded-md text-white border border-themeBlue hover:text-themeBlue hover:bg-transparent hover:border-themeBlue">
            <FaRegUser size={28} />
          </Link>
        </div>
      </div>
    </nav>
  );
}
